module.exports = __webpack_public_path__ + "img/6-3.e13fbffc.svg";